import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '../FormField/TextField';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: theme.spacing(1, 0),
  },
  subtitle: {
    fontSize: theme.typography.pxToRem(13),
    marginBottom: theme.spacing(2),
  },
  formHelperContained: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },
  description: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.props.palette.primary.main,
  },
}));

const ReasonTextField = ({
  label,
  subtitle,
  helperText,
  notification,
  required = false,
  onChange,
}) => {
  const classes = useStyles();
  return (
    <>
      {subtitle != null && <div className={classes.subtitle}>{subtitle}</div>}
      <div className={classes.wrapper}>
        <TextField
          label={label}
          helperText={helperText}
          variant="outlined"
          countWord
          multiline
          fullWidth
          onChange={onChange}
          rows={6}
          required={required}
          inputProps={{ maxLength: 255 }}
          InputLabelProps={{ shrink: true }}
          FormHelperTextProps={{
            classes: { contained: classes.formHelperContained },
          }}
        />
      </div>
      <Typography
        variant="subtitle2"
        className={clsx('text-break-all', classes.description)}
      >
        {notification}
      </Typography>
    </>
  );
};

ReasonTextField.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  helperText: PropTypes.string,
  notification: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

export default ReasonTextField;
